import React from 'react'
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import ProductYouLikes from '../../../details/module/youlikes'
import { useIntl } from 'react-intl'

export default props => {
    useStyles(classes)
    const intl = useIntl();

    return <>
        <div className={classes.Empty}>
            <img src="https://s3-us-west-2.amazonaws.com/static.geeko.online/image/cm/filternopro.png"/>
            <div className={classes.Text}>
                {props.title || `${intl.formatMessage({id:'no_more_data', defaultMessage:'No More Data'})}.`}
            </div>
        </div>

        <ProductYouLikes 
            sensors={{
                resourcepage_title: 'list',
                resource_position: '1',
                resource_type: '4',
                resource_content: 'You may also like'
            }}
        />
    </>
    
}